import { lazy } from 'react';
import { bookList } from 'src/constants/bookList';
import {
    NAV_REGISTRY,
    NOT_FOUND_ROUTE,
    NotFoundPage,
    getDefaultRoute,
} from 'src/config/navigation.registry';
import { toRouteDefinition } from 'src/config/navigation.utils';
import { filterRoutesByRole } from 'src/config/navigation.selectors';

const login = lazy(() => import('src/routes/auth/login'));

export { NotFoundPage, getDefaultRoute, filterRoutesByRole };

/**
 * All private route definitions (unfiltered).
 * The authenticated app shell uses `accessiblePrivateRoutesSelector` instead.
 */
export const privateRoutes = [
    ...NAV_REGISTRY.map(toRouteDefinition),
    {
        component: NOT_FOUND_ROUTE.component,
        path: NOT_FOUND_ROUTE.routePath,
        isDefault: true,
    },
];

export const publicRoutes = [
    {
        component: login,
        path: bookList.auth.login,
        isDefault: false,
    },
];
